var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgConsultation = function SvgConsultation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 42 42"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.8,
    d: "M24.499 15.749a3.5 3.5 0 0 1-3.5 3.5h-10.5l-7 7V6.999a3.51 3.51 0 0 1 3.5-3.5h14a3.5 3.5 0 0 1 3.5 3.5zM31.501 15.75h3.5a3.5 3.5 0 0 1 3.5 3.5V38.5l-7-7h-10.5a3.5 3.5 0 0 1-3.5-3.5v-1.75"
  })));
};
export default SvgConsultation;